import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './ideiaNegocioActions';
import TextoInput from '../texto/textoInput';

class IdeiaNegocioForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'>
					<ContentCard 
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.ideiaNegocioFormTitulo}</label>

							<TextoInput chave='ideiaNegocioFormTitulo' />

						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								<Row>
									<Field
										name='nome'
										component={LabelAndInput}
										label='Nome Completo: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='email'
										component={LabelAndInput}
										label='E-mail: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='cpf'
										component={LabelAndInputMask}
										label='CPF: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										mask='999.999.999-99' />

									<Field
										name='endereco'
										component={LabelAndInput}
										label='Endereço: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='celular'
										component={LabelAndInput}
										label='Telefone Celular: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										mask='(99) 9 9999-9999' />

									<Field
										name='vinculo'
										component={Select}
										options={[
											{ id: 'Aluno Unijuí', valor: 'Aluno Unijuí' },
											{ id: 'Egresso', valor: 'Egresso' },
											{ id: 'Comunidade', valor: 'Comunidade' }
										]}
										label='Informe seu Vínculo: *' placeholder=''
										cols='12 12 12 12'
										mask='(99) 9 9999-9999' />

									<Field
										name='area_conhecimento'
										component={LabelAndInput}
										label='Qual a sua área de conhecimento? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='nome_projeto'
										component={LabelAndInput}
										label='Nome do Projeto: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />

									<Field
										name='caracteristica'
										component={Select}
										options={[
											{ id: 'Base Tecnológica', valor: 'Base Tecnológica' },
											{ id: 'Negócios de Impacto', valor: 'Negócios de Impacto' }
										]}
										label='Como seu projeto se caracteriza?: *' placeholder=''
										cols='12 12 12 12'
										mask='(99) 9 9999-9999' />

									<Field
										name='equipe'
										component={LabelAndTextarea}
										label='Quem esta nessa jornada com você, descreva sua equipe? *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

									<Field
										name='problema'
										component={LabelAndTextarea}
										label='Descreva de forma objetiva, o problema que pretende resolver, destaque as oportunidades de mercado, potencial de escala: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

									<Field
										name='solucao'
										component={LabelAndTextarea}
										label='Descreva o produto/serviço/processo/modelo de negócio que esta sendo idealizado: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

									<Field
										name='diferencial'
										component={LabelAndTextarea}
										label='Explique o que faz sua proposta ter um diferencial em relação ao que já existe: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

									<Field
										name='equipe_descricao'
										component={LabelAndTextarea}
										label='Descreva sua equipe e explique porque é ideal para o projeto proposto: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										rows={3} />

								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (!this.props.sessao.administrador ? (
											<Button
												text='Salvar'
												submit
												type={'success'}
												icon={'fa fa-check'} />
										) : null)}
									</Grid>}
									<Grid cols='4 4 4 4'>
										<Button
											text='Voltar'
											type={'success'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IdeiaNegocioForm = reduxForm({form: 'ideiaNegocioForm', destroyOnUnmount: false})(IdeiaNegocioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('ideiaNegocioForm')(state),
	registro: state.ideiaNegocio.registro,
	lista: state.ideiaNegocio.lista,
	ideiaNegocioFormTitulo: state.texto.lista.filter(item => item.chave == 'ideiaNegocioFormTitulo').map(item => item.valor)[0],
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IdeiaNegocioForm);
